<template>
  <div class="home-bottom-bar">
    <div
      :class="className"
      :id="id"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
import resize from "../mixins/resize";

export default {
  name: "ShengLiangQushi",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "170px"
    },
    colorList: {
      type: Array,
      default() {
        return ["#ffe05f", "#a1e058", "#00d8ae", "#00cdff", "#0080ff"];
      }
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null,
      option: null,
      curtab: 0
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      let series = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        let temp = {
          name: this.chartData.data[i].legend,
          type: "line",
            smooth: true,
            symbol:"none",
            stack: "总量",
          itemStyle: {
            normal: {
              lineStyle: {
                opacity: 0.5
              },
              areaStyle: {
                opacity: 0.3
              }
            }
          },

            data: this.chartData.data[i].valueList
        };

        series.push(temp);
      }
      this.option = {
        color: this.colorList,
        // title: {
        //   show: this.chartData.showTitle === false ? false : true,
        //   text: this.chartData.title != null ? this.chartData.title : "",
        //     // text:"",
        //   textStyle: {
        //     color: "#cbeeff"
        //   },
        //   x: "center",
        //   y: "top",
        //   top: -6,
        //   textAlign: "left"
        // },
        grid: {
          top: "20%",
          bottom: "0%",
          left: "2%",
          right: "1%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          // triggerOn: "none",
          confine: true,
          textStyle: {
            color: "#cbeeff"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },

        legend: {
          // orient: "vertical",
          data: this.chartData.legendList,
          top: 0,
          left: "center",
          // itemGap: 20,
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#cbeeff"
          }
        },

        xAxis: [
          {
              show:true,
            name: this.chartData.showYAxisTitle === false ? "" : "",
            nameLocation: "end", //坐标轴名称显示位置。可选：'start','middle','end'

            nameTextStyle: {
              color: "#cbeeff", //文字颜色
              fontStyle: "normal", //italic斜体  oblique倾斜
              fontWeight: "normal", //文字粗细bold   bolder   lighter  100 | 200 | 300 | 400...
              fontFamily: "sans-serif" //字体系列
            }, //坐标轴名称的文字样式
            type: "category",
            boundaryGap: false,
            data: this.chartData.nameList,

            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#132847"
              }
            },
            axisLabel: {
              color: "#cbeeff",
              interval: 0

              // rotate: 15
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.chartData.showYAxisTitle === false ? "" : "新闻量",

            show: true,
            /* min: 0,
            max: 1500,*/
            // interval: 50,
            axisLabel: {
              color: "#cbeeff",
              formatter: "{value}"
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#cbeeff"
              }
            },
            splitLine: {
              show: false
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                shadowOffsetX: 0 //阴影水平方向上的偏移距离。
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: series
        /* [
          {
            name: "西湖",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { color: "#3972ff" } },
            data: [120, 132, 101, 134, 90, 230, 210, 90]
          },
          {
            name: "广州长隆",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { color: "#38b5f3" } },
            data: [220, 182, 191, 234, 290, 330, 310, 182]
          },
          {
            name: "长白山",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { color: "#06c5a1" } },
            data: [150, 232, 201, 154, 190, 330, 410, 232]
          },
          {
            name: "上海迪士尼",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { color: "#f2ea5f" } },
            data: [320, 332, 301, 334, 390, 330, 320, 332]
          },
          {
            name: "三亚市",
            type: "line",
            stack: "总量",
            itemStyle: { normal: { color: "#3972ff" } },
            data: [820, 932, 901, 934, 1290, 1330, 1320, 932]
          }
        ]*/
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
      this.chart.on("click", function(params) {
        console.log(params);
        // this.chart.dispatchAction({
        //   type: "showTip",
        //   seriesIndex: params.seriesIndex,
        //   dataIndex: params.dataIndex
        // });
      });
    }
  }
};
</script>
<style scoped lang="less">
.home-bottom-bar {
  width: 100%;
  height: 100%;
  position: relative;
  .tab-group {
    height: 0.3rem;
    line-height: 0.3rem;
    position: absolute;
    z-index: 999;
    right: 0.15rem;
    top: 0;
    color: @base-text-color;
    > div {
      float: left;
      padding-right: 0.15rem;
      position: relative;
      > div {
        float: left;
      }
      .icon {
        width: 0.3rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .text {
        cursor: pointer;
      }
      ul {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.3rem;
        li {
          width: 100%;
          height: 0.22rem;
          line-height: 0.22rem;
          border: 1px solid #0c6398;
          background: rgba(0, 183, 247, 0.2);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
